import HandleRegister from "./HandleRegister";

const Server_Side_Register = async (
  e,
  username_register,
  password_register,
  email,
  get_user,
  handleAlert,
  setGif,
  history,
  errors,
  setErrors
) => {
  setGif(true);
  e.preventDefault();
  const response = await HandleRegister({
    username: username_register,
    password: password_register,
    email,
    errors,
    setErrors,
  });

  if (response) {
    let { jwt: token } = response.data;
    let user = { token };
    handleAlert({
      show: true,
      type: "success",
      text: `Welcome You are registered with success`,
    });
    get_user(user);
    setGif(false);
    history.push("/");
  } else {
    handleAlert({
      show: true,
      type: "error",
      text: `Something went wrong, please try again `,
    });
    setGif(false);
  }
};

export { Server_Side_Register as default };
